export default "__VITE_ASSET__d654ecad__"